var map = {
	"./_base.js": "4022",
	"./admin-followup.js": "77fe",
	"./chatbot-qa.js": "89f4",
	"./claim-form.js": "931d",
	"./claims.js": "d2b1",
	"./company.js": "f0de",
	"./department-form.js": "6344",
	"./departments.js": "2584",
	"./employee-add.js": "d0ad",
	"./employee-import.js": "7446",
	"./employee-page.js": "a230",
	"./employees.js": "7d65",
	"./notifications.js": "cbf1",
	"./policy-contract.js": "b8bb",
	"./providers.js": "182f",
	"./reports.js": "982f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2af";